/** Progressive size switching; modified clicks keep normal link behaviour. */
export default () => ({
    selectSize(event) {
        const link = event.target.closest('a[data-size-id]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const template = Array.from(this.$el.querySelectorAll('template[data-card-size]'))
            .find((item) => item.dataset.cardSize === link.dataset.sizeId);
        if (!template) return;
        event.preventDefault();
        event.stopPropagation();
        if (link.getAttribute('aria-current') === 'true') return;
        const content = this.$el.querySelector('[data-card-content]');
        // Keep the previous photograph visible until the next one has decoded.
        // On rapid clicks, carry forward the still-visible overlay, if any.
        const previous = content.querySelector('[data-photo-outgoing]')
            || content.querySelector('.photo-img');
        const outgoing = previous?.cloneNode(true);
        content.replaceChildren(template.content.cloneNode(true));
        const incoming = content.querySelector('.photo-img');
        if (outgoing && incoming && outgoing.getAttribute('src') !== incoming.getAttribute('src')) {
            outgoing.dataset.photoOutgoing = '';
            outgoing.style.pointerEvents = 'none';
            incoming.after(outgoing);
            incoming.loading = 'eager';
            const ready = incoming.decode ? incoming.decode() : Promise.resolve();
            ready.catch(() => {}).then(() => {
                if (!outgoing.isConnected) return;
                if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !outgoing.animate) {
                    outgoing.remove();
                    return;
                }
                const fade = outgoing.animate([{ opacity: 1 }, { opacity: 0 }], {
                    duration: 220,
                    easing: 'ease-out',
                    fill: 'forwards',
                });
                fade.finished.then(() => outgoing.remove()).catch(() => outgoing.remove());
            });
        }
        content.querySelector('a[aria-current="true"]')?.focus({ preventScroll: true });
    },
});
